import {
  getSupplementalId,
  showWhenSupplementalDistrictHeatingCondition,
} from "../supplemental-heating.util";
import { Section } from "../types";

export function supplementalDistrictHeatingInputSections(
  prefix: string
): Section[] {
  const id = (districtHeadingParameterId: string) =>
    getSupplementalId(prefix, districtHeadingParameterId);
  return [
    {
      title: "Flöde fjärrvärmespets",
      parameters: [id("DistrictHeatingFlowCost")],
      conditions: [showWhenSupplementalDistrictHeatingCondition],
    },
    {
      title: "Investeringskostnad fjärrvärmespets",
      parameters: [
        id("DistrictHeatingCentralCost"),
        id("DistrictHeatingCentralLifeSpan"),
        id("DistrictHeatingConnectionCost"),
        id("DistrictHeatingConnectionLifeSpan"),
      ],
      conditions: [
        showWhenSupplementalDistrictHeatingCondition,
        { parameter: "DistrictHeatingInstalled", value: false },
      ],
    },
    {
      title: "Drift- och underhållskostnader fjärrvärmespets",
      parameters: [id("DistrictHeatingMaintenanceCost")],
      conditions: [showWhenSupplementalDistrictHeatingCondition],
    },
  ];
}

export function supplementalDistrictHeatingCostSummarySections(
  prefix: string
): Section[] {
  const id = (districtHeadingParameterId: string) =>
    getSupplementalId(prefix, districtHeadingParameterId);
  return [
    {
      title: "Årliga kostnader för fjärrvärmespets",
      parameters: [
        id("DistrictHeatingCapitalCost"),
        id("DistrictHeatingMaintenanceCost"),
        id("DistrictHeatingEnergyCost"),
        id("DistrictHeatingLoadCost"),
        id("DistrictHeatingFlowCost"),
      ],
      conditions: [showWhenSupplementalDistrictHeatingCondition],
    },
    {
      title: "",
      parameters: [id("DistrictHeatingTotalSpecificCost")],
      conditions: [showWhenSupplementalDistrictHeatingCondition],
    },
  ];
}
